<div class="main-content">
    <div class="main-heading">
        <span>
            <span translate>KUBA_CONTROL_OBJECT</span>
        </span>
        <span *ngIf="isKcRights" class="page-actions text-right">
            <a [routerLink]="['./../edit/0']" class="btn btn-success">
                <i class="pi pi-plus"></i>
                <span>
                    <span translate>NEW</span>
                </span>
            </a>
        </span>
    </div>
    <div class="panel-tabs">
        <nav>
            <ul class="nav nav-pills">
                <li [routerLinkActive]="['active']" *ngIf="isKcRights">
                    <a [routerLink]="['./all']" translate>ALL</a>
                </li>
                <li [routerLinkActive]="['active']" *ngIf="hideKcRights">
                    <a [routerLink]="['./own']" translate>FOR_YOU</a>
                </li>
            </ul>
        </nav>
    </div>
    <div class="card">
        <div class="card-body">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>